import api from './api';

export async function getVipClicks({ page = 1, limit = 20, sort = 'newest' } = {}) {
  const params = { page, limit };

  if (sort) params.sort = sort;

  const response = await api.get('/admin/vip-clicks', { params });
  return response.data;
}
